var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard-11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Invoice"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63,45H56V58a4,4,0,0,0,8,0V46A1,1,0,0,0,63,45Z",
    style: {
      fill: "#00A7A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,58V1a1.012,1.012,0,0,0-.56-.9,1.044,1.044,0,0,0-1.05.1L47.75,3.74,43.1.2a1.02,1.02,0,0,0-1.22,0L37.24,3.74,32.6.2a1,1,0,0,0-1.21,0L26.74,3.74,22.1.2a1,1,0,0,0-1.21,0L16.25,3.74,11.61.2A1.022,1.022,0,0,0,10.56.1,1.012,1.012,0,0,0,10,1V34H45a3.009,3.009,0,0,1,3,3V64H60A6,6,0,0,1,54,58ZM44,30H15a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Zm0-5H15a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Zm0-5H15a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Zm0-5H15a1,1,0,0,1,0-2H44a1,1,0,0,1,0,2Zm5,15H47a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-5H47a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-5H47a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-5H47a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Zm0-5H15a1,1,0,0,1,0-2H49a1,1,0,0,1,0,2Z",
    style: {
      fill: "#00A7A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,48a1,1,0,0,0,1,1V47A1,1,0,0,0,21,48Z",
    style: {
      fill: "#00A7A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.083,42H10.917A6.017,6.017,0,0,1,6,46.917v6.166A6.017,6.017,0,0,1,10.917,58H35.083A6.017,6.017,0,0,1,40,53.083V46.917A6.017,6.017,0,0,1,35.083,42ZM24,55a1,1,0,0,1-2,0H21a1,1,0,0,1,0-2h1V51a3,3,0,0,1,0-6,1,1,0,0,1,2,0h1a1,1,0,0,1,0,2H24v2a3,3,0,0,1,0,6Z",
    style: {
      fill: "#00A7A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,51v2a1,1,0,0,0,0-2Z",
    style: {
      fill: "#00A7A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,36H1a1,1,0,0,0-1,1V63a1,1,0,0,0,1,1H46V37A1,1,0,0,0,45,36ZM42,54a1,1,0,0,1-1,1,4,4,0,0,0-4,4,1,1,0,0,1-1,1H10a1,1,0,0,1-1-1,4,4,0,0,0-4-4,1,1,0,0,1-1-1V46a1,1,0,0,1,1-1,4,4,0,0,0,4-4,1,1,0,0,1,1-1H36a1,1,0,0,1,1,1,4,4,0,0,0,4,4,1,1,0,0,1,1,1Z",
    style: {
      fill: "#00A7A9"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.98a748c491969e323e0b6b31c0ca1cfe.svg";
export { ForwardRef as ReactComponent };